'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _KEYS$SIGNUP_MODE$KEY;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var KEYS = exports.KEYS = {
  SIGNUP_MODE: 'SIGNUP_MODE',
  LANDING_PAGE_TYPE: 'LANDING_PAGE_TYPE',
  AUTOFOCUS_DISABLED: 'AUTOFOCUS_DISABLED'
};

exports.default = (_KEYS$SIGNUP_MODE$KEY = {}, _defineProperty(_KEYS$SIGNUP_MODE$KEY, KEYS.SIGNUP_MODE, 'signupMode'), _defineProperty(_KEYS$SIGNUP_MODE$KEY, KEYS.LANDING_PAGE_TYPE, 'landingPageType'), _defineProperty(_KEYS$SIGNUP_MODE$KEY, KEYS.AUTOFOCUS_DISABLED, 'autofocusDisabled'), _KEYS$SIGNUP_MODE$KEY);